import { render, staticRenderFns } from "./convenientMenuGroup.vue?vue&type=template&id=15cd4de6&functional=true&"
import script from "./convenientMenuGroup.vue?vue&type=script&lang=js&"
export * from "./convenientMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/items/convenientMenuGroup.vue"
export default component.exports